import AppCompaniesIndex from "./company.vue";
import AppCompaniesList from "./list/list.vue";
import AppCompaniesItem from "./item/item.vue";

const routes = [
  {
    path: "/company",
    component: AppCompaniesIndex,
    meta: {
      auth: {
        roles: "company.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "company.index",
        component: AppCompaniesList,
        meta: {
          auth: {
            roles: "company.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "company.create",
        component: AppCompaniesItem,
        meta: {
          auth: {
            roles: "company.create",
            redirect: { name: "company.index" }
          }
        }
      },
      {
        path: ":id",
        name: "company.edit",
        component: AppCompaniesItem,
        meta: {
          auth: {
            roles: "company.update",
            redirect: { name: "company.index" }
          }
        }
      }
    ]
  }
];

export default routes;
